import request from '@/_util/require';
let version = 'v1';

/** 新增活动计划 */
export async function addActivityPlan(options) {
  return request(`/${version}/waper/erp/pc/osa/activity/plan/add`, {
    method: 'POST',
    data: options,
  });
}

/** 删除活动计划 */
export async function deleteActivityPlan(params) {
  return request(`/${version}/waper/erp/pc/osa/activity/plan/delete`, {
    method: 'GET',
    params,
  });
}

/** 将所有活动计划拆分为每日数据 */
export async function getAllSplitActivityPlan(params) {
  return request(`/${version}/waper/erp/pc/osa/activity/plan/getAllSplit`, {
    method: 'GET',
    params,
  });
}

/** 分页查询活动计划 */
export async function getActivityPlanByDateRange(options) {
  return request(`/${version}/waper/erp/pc/osa/activity/plan/pageList`, {
    method: 'POST',
    data: options,
  });
}

/** 根据ID查询活动计划 */
export async function getActivityPlanInfo(params) {
  return request(`/${version}/waper/erp/pc/osa/activity/plan/getInfo`, {
    method: 'GET',
    params,
  });
}

/** 修改活动计划 */
export async function updateActivityPlan(data) {
  return request(`/${version}/waper/erp/pc/osa/activity/plan/update`, {
    method: 'POST',
    data,
  });
}
